// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tooltip-label-info-container {
  min-width: 250px;
  width: 100%;
  max-width: 300px;
  min-height: 50px;
  font-size: 0.99rem;
  line-height: 1.2;
  text-align: left;
  padding: 5px;
  font-weight: 200;
  white-space: normal;
  font-style: normal;
  background: rgba(234, 234, 79, 0.5);
}

.tooltip-label-info {
  font-size: 1.2rem;
  color: #317d03;
  position: relative;
  white-space: normal;
  font-style: normal;
  line-height: 0;
  margin-bottom: 5px;
}

.tooltip-label-info:before {
  content: "\\f29c";
  font-family: "FontAwesome";
}

.symLabel-wrapper {
  display: inline-flex;
  align-items: center;
}

.xmlCol {
  padding-left: 0px !important;
  padding-right: 10px !important;
}

.xmlRow {
  padding-left: 10px !important;
}`, "",{"version":3,"sources":["webpack://./src/app/system-common/xml-config-ui/xml-config-ui.component.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mCAAA;AACF;;AAEA;EACE,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;AACF;;AAEA;EACE,gBAAA;EACA,0BAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;AACF;;AAEA;EACE,4BAAA;EACA,8BAAA;AACF;;AAEA;EACE,6BAAA;AACF","sourcesContent":[".tooltip-label-info-container {\n  min-width: 250px;\n  width: 100%;\n  max-width: 300px;\n  min-height: 50px;\n  font-size: 0.99rem;\n  line-height: 1.2;\n  text-align: left;\n  padding: 5px;\n  font-weight: 200;\n  white-space: normal;\n  font-style: normal;\n  background: rgb(234 234 79 / 50%);\n}\n\n.tooltip-label-info {\n  font-size: 1.2rem;\n  color: #317d03;\n  position: relative;\n  white-space: normal;\n  font-style: normal;\n  line-height: 0;\n  margin-bottom: 5px;\n}\n\n.tooltip-label-info:before {\n  content: '\\f29c';\n  font-family: 'FontAwesome';\n}\n\n.symLabel-wrapper {\n  display: inline-flex;\n  align-items: center;\n}\n\n.xmlCol {\n  padding-left: 0px !important;\n  padding-right: 10px !important;\n}\n\n.xmlRow {\n  padding-left: 10px !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
